var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from "react";
import { connect } from "react-redux";
import { injectIntl, defineMessages } from "react-intl";
import { FormControl } from "react-bootstrap";
import classNames from "classnames";
import { PROVIDER_SORT_OPTIONS, PROVIDER_SORT_BY_POPULARITY, PROVIDER_SORT_BY_NAME_ASC, PROVIDER_SORT_BY_NAME_DESC, PROVIDER_SORT_BY_NEWEST, } from "../../../../constants/gamesSort";
import { setProviderSortType, clearGames, searchGames, } from "../../../../actions/games/creators";
var messages = defineMessages({
    sortLabel: {
        id: "games.sort_label",
        defaultMessage: "Сортировка",
    },
    sortByPopularity: {
        id: "games.sort_by_popularity",
        defaultMessage: "По популярности",
    },
    sortByNewest: {
        id: "games.sort_by_newest",
        defaultMessage: "По новизне",
    },
    sortByNameAsc: {
        id: "games.sort_by_name_asc",
        defaultMessage: "По алфавиту A-Z",
    },
    sortByNameDesc: {
        id: "games.sort_by_name_desc",
        defaultMessage: "По алфавиту Z-A",
    },
});
var SORT_MESSAGE_MAP = (_a = {},
    _a[PROVIDER_SORT_BY_POPULARITY] = messages.sortByPopularity,
    _a[PROVIDER_SORT_BY_NEWEST] = messages.sortByNewest,
    _a[PROVIDER_SORT_BY_NAME_ASC] = messages.sortByNameAsc,
    _a[PROVIDER_SORT_BY_NAME_DESC] = messages.sortByNameDesc,
    _a);
var GamesProviderSort = /** @class */ (function (_super) {
    __extends(GamesProviderSort, _super);
    function GamesProviderSort() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formatFilterOptions = function (option) {
            return Array.from(option)
                .map(function (item) { return item[0]; })
                .join(",");
        };
        _this.handleSortChange = function (e) {
            var sortType = Number(e.target.value);
            var _a = _this.props, user = _a.user, selectedProviders = _a.selectedProviders, selectedTypes = _a.selectedTypes, isTop = _a.isTop, limit = _a.limit;
            var types = _this.formatFilterOptions(selectedTypes);
            var providers = _this.formatFilterOptions(selectedProviders);
            _this.props.setProviderSortTypeAction(sortType);
            _this.props.clearGamesAction();
            _this.props.searchGamesAction({
                name: "",
                types: types,
                providers: providers,
                gamblerId: user.gamblerId,
                isTop: isTop,
                limit: limit,
                offset: 0,
                sortType: sortType,
            });
        };
        return _this;
    }
    GamesProviderSort.prototype.render = function () {
        var _a = this.props, intl = _a.intl, darkTheme = _a.darkTheme, providerSortType = _a.providerSortType;
        return (_jsx("div", __assign({ className: "games-provider-sort" }, { children: _jsx(FormControl, __assign({ componentClass: "select", value: providerSortType, onChange: this.handleSortChange, "aria-label": intl.formatMessage(messages.sortLabel), className: classNames("games-provider-sort__select", {
                    "games-provider-sort__select--dark": darkTheme,
                }) }, { children: PROVIDER_SORT_OPTIONS.map(function (sortType) { return (_jsx("option", __assign({ value: sortType }, { children: intl.formatMessage(SORT_MESSAGE_MAP[sortType]) }), sortType)); }) })) })));
    };
    return GamesProviderSort;
}(Component));
var mapStateToProps = function (state) {
    var _a = state.games.gamesFilter, providerSortType = _a.providerSortType, selectedTypes = _a.selectedTypes, selectedProviders = _a.selectedProviders;
    var _b = state.games.games, data = _b.data, isTop = _b.isTop;
    return {
        providerSortType: providerSortType,
        selectedTypes: selectedTypes,
        selectedProviders: selectedProviders,
        isTop: isTop,
        limit: data.Limit,
        user: state.auth.user,
        darkTheme: state.application.get("darkTheme"),
    };
};
var mapDispatchToProps = {
    setProviderSortTypeAction: setProviderSortType,
    clearGamesAction: clearGames,
    searchGamesAction: searchGames,
};
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(GamesProviderSort));



// WEBPACK FOOTER //
// ./src/components/games/components/GamesProviderSort/GamesProviderSort.jsx